import { Category } from "scenes/cohort-filters/filter-configs/categories";
import { WidgetType } from "scenes/cohort-filters/filter-configs/widgetTypes";

export const dropdownFieldConfigConstructor = ({
    pathToValue,
    category = Category.OTHER,
    dropdownValues,
    label,
    fieldWidth = null,
    nestedComponent = false,
}) => ({
    [pathToValue]: {
        widgetType: WidgetType.DROPDOWN,
        category: nestedComponent ? undefined : category,
        widgetConfig: {
            label,
            values: dropdownValues,
            width: fieldWidth,
        },
    },
});
